export default __webpack_public_path__ + "static/20_off-5dd4f36b375ec8f1f1daef90b16b5ea0.png";